import React from 'react';
import { Datagrid, Show, TextField, ReferenceManyField, DeleteButton, EditButton, useRefresh, usePermissions, SimpleShowLayout, RichTextField, Pagination } from 'react-admin';
import BackButton from '../components/BackButton';
import LocationAdd from '../locations/LocationAdd';
import CardActions from "@material-ui/core/CardActions";
import ISConfig from '../config';
import CustomDefaultShowComponent from '../components/CustomDefaultShowComponent';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import LocationsIcon from '@material-ui/icons/Apartment';
import QuickBookIcon from '@material-ui/icons/CollectionsBookmark';

const CustomersShowActions = ({ basePath, data }) => (
    <CardActions>
        <BackButton style={{ marginRight: "auto" }}></BackButton>
        <EditButton basePath={basePath} record={data} />
    </CardActions>
);

const CustomerShowGeneral = ({ record }) => {
    const { name, status, client_code, email } = record;

    return (
        <div className="row">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row row-cols-3 row-cols-lg-3 g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Client Code </h6>
                        {client_code ? client_code.length > 0 ? <span className="fw-italic m-0 p-0">{client_code}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Name </h6>
                        {name ? name.length > 0 ? <span className="fw-italic m-0 p-0">{name}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Status</h6>
                        {status ? status.length > 0 ? <span className="fw-italic m-0 p-0">{status}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                </div>
                <div className="row g-2 g-lg-2 mb-2">
                    <div >
                        <CustomerShowAddress record={record} />
                    </div>
                </div>
                <div className="row g-2 g-lg-2 mb-2">
                    <div>
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Email</h6>
                        {email ? email.length > 0 ? <span className="fw-italic text-lowercase">{email}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 mb-3 m-o p-0">
                <CustomerShowNotes record={record} />
            </div>
        </div>
    );
};

const CustomerShowNotes = ({ record }) => {
    const { notes } = record;

    return (
        <div className="row h-100 w-100 m-0 p-0">
            <div>
                <h6 className="text-secondary" style={{ marginBottom: '10px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Notes</h6>
                <div className="p-2 pb-0 w-100 h-100" style={{ backgroundColor: 'rgb(255, 238, 201)', borderRadius: '0px 5px 5px 5px' }}>
                    {notes ? notes.length > 0 ? <RichTextField source="notes" style={{ fontSize: '1em' }} /> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                </div>
            </div>
        </div>
    );
};

const CustomerShowQuickbooks = ({ record }) => {
    const { qb_active, qb_notes, qbid } = record;

    return (
        <div className="col-12 col-xs-12 col-md-3">
            <h6 className="font-weight-normal pt-2">{<QuickBookIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Quickbooks</h6>
            <div className="row row-cols-2 row-cols-lg-2 g-2 g-lg-2 mb-2">
                <div>
                    <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Status</h6>
                    <span className={(qb_active) ? 'text-success' : 'text-danger'}>{(qb_active) ? <CheckIcon /> : <ClearIcon />}</span>
                </div>
                <div>
                    <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Notes </h6>
                    {qb_notes ? qb_notes.length > 0 ? <RichTextField source="qb_notes" style={{ fontSize: '1em' }} /> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                </div>
            </div>
        </div>
    );
}

const CustomerShowAddress = ({ record }) => {
    const { address } = record;
    var CustomDefaultShowComponent = <span className="text-secondary" style={{ fontStyle: 'italic' }}>empty </span>;

    return (
        <div>
            <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Address</h6>
            <div>
                {address.street ? address.street.length > 0 ? <span className="fw-italic">{address.street}</span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
            <div>
                {address.city ? address.city.length > 0 ? <span className="fw-italic">{address.city} </span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                {address.state ? address.state.length > 0 ? <span className="fw-italic text-uppercase">{address.state} </span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
                {address.zip ? address.zip.length > 0 ? <span className="fw-italic text-uppercase">{address.zip} </span> : CustomDefaultShowComponent : CustomDefaultShowComponent}
            </div>
        </div>
    );
};

const LocationSectionTitle = ({ record }) => {
    return (
        <div className="d-flex align-items-center">
            <h5 className="font-weight-normal pt-2">{<LocationsIcon className="d-inline text-danger" style={{ fontSize: '38px' }} />} Locations </h5>
            <LocationAdd className="d-inline-block" record={record} onChange={useRefresh()} />
        </div>)
}


const CustomerShow = (props) => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    let locationDeleteButton = null;
    if (isAdmin) { locationDeleteButton = ( <DeleteButton redirect={toRedirect} /> ) }

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Customer</h3>
            <Show actions={<CustomersShowActions />} title=" "  {...props}>
                <SimpleShowLayout>
                    <CustomerShowGeneral className="mb-3" record={{ ...props }} />
                    {(ISConfig.qbi) ? <CustomerShowQuickbooks className="mb-3" record={{ ...props }} /> : ''}
                    <LocationSectionTitle record={{ ...props }} />
                    <ReferenceManyField
                        addLabel={false}
                        reference="locations"
                        target="customer_id"
                        source="id"
                        sort={{ field: 'name', order: 'DESC' }}
                        display="flex" flex="0 0 100%" flexWrap="wrap"
                        pagination={<Pagination />}
                        perPage={10}
                        emptyText="Nothing to show"
                    >
                        <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                            <TextField source="name" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name </h6>} />
                            <TextField source="status" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Status </h6>} />
                            <TextField source="address.street" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Street </h6>} />
                            <TextField source="address.city" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>City </h6>} />
                            <TextField source="address.state" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>State </h6>} />
                            <TextField source="address.zip" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Zip </h6>} />
                            <TextField source="contact.display_name" label={<h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Contact </h6>} />
                            {locationDeleteButton}
                        </Datagrid>
                    </ReferenceManyField>
                </SimpleShowLayout>
            </Show>
        </>
    )
};

export default CustomerShow;
